import { ColorVariables, ThemesColors } from "./theme";

export const commonColors: ColorVariables = {
  gray: "#ababae",
  gray2: "#777777",
  lightGray: "#d3d3d3",
  lightGray2: "#e6e6e6",
  lightGray3: "#eeeef0",
  lightGray3_rgb: "238, 238, 240",
  lightGray4: "#c7c7c9",
  extraLightGray: "#fafafa",
  extraLightGray2: "#fcfcfc",
  extraLightGray3: "#fefefe",
  white: "#ffffff",
  white_rgb: "255, 255, 255",
  black: "#000",
  black_rgb: "0, 0, 0",
  dark: "#333333",
  dark_rgb: "51, 51, 51",
  red: "#e74a4a",
  red_rgb: "231, 74, 74",
  red2: "#e14f4f",
  lightGreen: "#8ad560",
  yellow: "#f0af3b",
  orange: "#f49035",
  lightPurple: "#f6f7fe",
  whiteSmoke: "#f5f5f6",
  title_color: "rgba(0, 0, 0, 0.87)",
  sub_title_color: "rgba(0, 0, 0, 0.54)",
};

export const themesColors: ThemesColors = {
  purple: {
    primary: "#007aff",
    primary_rgb: "79, 92, 225",
    primaryDark: "#4d58c6",
    primaryLight: "#8b93e3",
    primaryLight2: "#cdd1f9",
    primaryLight3: "#f6f7fd",
  },
  blue: {
    primary: "#4C82FD",
    primary_rgb: "76, 130, 253",
    primaryDark: "#418ADB",
    primaryLight: "#65A0E2",
    primaryLight2: "#CBE4FF",
    primaryLight3: "#F6FAFF",
  },
  darkBlue: {
    primary: "#03467F",
    primary_rgb: "3, 70, 127",
    primaryDark: "#013460",
    primaryLight: "#376994",
    primaryLight2: "#B3D3ED",
    primaryLight3: "#FAFDFF",
  },
  green: {
    primary: "#4DB48A",
    primary_rgb: "77, 180, 138",
    primaryDark: "#419673",
    primaryLight: "#83BBA4",
    primaryLight2: "#BEDED1",
    primaryLight3: "#F6FDFA",
  },
  turquoise: {
    primary: "#31C0C9",
    primary_rgb: "49, 192, 201",
    primaryDark: "#259CA3",
    primaryLight: "#88C6CA",
    primaryLight2: "#CCEAEC",
    primaryLight3: "#F6FDFA",
  },
  orange: {
    primary: "#EE7D24",
    primary_rgb: "238, 125, 36",
    primaryDark: "#C5661C",
    primaryLight: "#F29851",
    primaryLight2: "#FFDBBE",
    primaryLight3: "#FEF8F4",
  },
};
